// ** React Imports
import { Suspense } from "react"
import { createRoot } from "react-dom/client"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
// ** Redux Imports
import { store } from "./redux/store"
import { Provider } from "react-redux"
// ? Not good but no choice -> explained why inside the file
import CustomStoreWrapper from "@store/CustomStoreWrapper"
// ** Intl, CASL & ThemeColors Context
import ability from "./configs/acl/ability"
import { AbilityContext } from "./utility/context/Can"
import { ThemeContext } from "./utility/context/ThemeColors"
// ** ThemeConfig
import themeConfig from "./configs/themeConfig"
// ** Toast
import { Toaster } from "react-hot-toast"
// ** i18n
import "./configs/i18n"
// ** Spinner (Splash Screen)
import Spinner from "./@core/components/spinner/Fallback-spinner"
// ** Ripple Button
import "./@core/components/ripple-button"
// ** PrismJS
import "prismjs"
import "prismjs/themes/prism-tomorrow.css"
import "prismjs/components/prism-jsx.min"
// ** React Perfect Scrollbar
import "react-perfect-scrollbar/dist/css/styles.css"
// ** React Hot Toast Styles
import "@styles/react/libs/react-hot-toasts/react-hot-toasts.scss"
// ** Core styles
import "./@core/assets/fonts/feather/iconfont.css"
import "./@core/scss/core.scss"
import "./assets/scss/style.scss"
// ** Error Boundary
import Error from "./views/pages/misc/Error"
// ** Routes
import Visits from "./views/CRM/visits"
import VisitsList from "./views/CRM/visits/list"
import PersonsToValidate from "./views/CRM/personsToValidate"
// ** Service Worker
import * as serviceWorker from "./serviceWorker"
// ** Views
import IndexCRM from "./views/CRM"
import IndexToolbox from "./views/toolbox/index"

const container = document.getElementById("root")
const root = createRoot(container)

const router = createBrowserRouter([
  {
    path: "/",
    index: true,
    element: <IndexCRM />,
    errorElement: <Error />
  },
  {
    path: "Toolbox",
    element: <IndexToolbox />,
    errorElement: <Error />
  },
  {
    path: "CRM",
    element: <IndexCRM />,
    errorElement: <Error />
  },
  {
    path: "CRM/Create",
    element: <Visits />,
    errorElement: <Error />
  },
  {
    path: "CRM/PersonsToValidate",
    element: <PersonsToValidate />,
    errorElement: <Error />
  },
  {
    path: "CRM/Visits",
    element: <Visits />,
    errorElement: <Error />,
    children: [
      {
        element: <Visits />,
        path: ":personId",
        errorElement: <Error />,
        children: [
          {
            path: ":action",
            element: <Visits />
          }
        ]
      }
    ]
  },
  {
    path: "Visits/List",
    element: <VisitsList />,
    errorElement: <Error />
  }
])

root.render(
  <Provider store={store}>
    <Suspense fallback={<Spinner />}>
      <AbilityContext.Provider value={ability}>
        <ThemeContext>
          <CustomStoreWrapper>
            <RouterProvider router={router}></RouterProvider>
            <Toaster
              position={themeConfig.layout.toastPosition}
              toastOptions={{ className: "react-hot-toast" }}
            />
          </CustomStoreWrapper>
        </ThemeContext>
      </AbilityContext.Provider>
    </Suspense>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
